<style scoped lang="scss">
.breads{
  overflow:auto;line-height: 48px;margin-bottom:  20px;
}
.desc{
  font-size: 16px;text-indent: 0;margin-bottom:20px;
}
.compose-type{
    background: #f6fafd;
    padding-bottom: 80px;
    margin-top: 100px;
}
@media screen and (max-width: 640px) {
  .compose-type {
    margin-top: 50px;
    padding-bottom: 30px;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <!--  基因合成-快速基因合成 -->
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <!-- banner -->
    <gene-top-banner :smallTitle="smallTitle" :bigTitle="bigTitle"></gene-top-banner>
    <section v-if="!$route.meta.invisibles">
      <!-- 导航 -->
      <div class="breads container">
        <bread></bread>
      </div>
      <!-- 概述 -->
      <div class="container">
        <p class="desc">擎科生物推出快速基因合成服务，快至5个自然日交付项目，节约您的合成时间，加快您的实验进程。</p>
      </div>
      <!-- 产品优势 -->
      <div class="compose-type">
        <div class="container">
          <en-title title="产品优势" enTitle="Advantages"></en-title>
          <gene-advantages :menuTitle="bigTitle" :advantagesList="advantagesList" ></gene-advantages>
        </div>
      </div>
      <!-- 服务内容 -->
      <div class="container">
        <en-title title="服务内容" enTitle="Service Details"></en-title>
        <gene-detail-table :tableColumn="tableColumn" :tableData="tableData" :tableSpanMethod="tableSpanMethod"></gene-detail-table>
      </div>
      <!-- 交付结果 -->
      <div class="container">
        <en-title title="交付结果" enTitle="Deliverables"></en-title>
        <gene-deliverables :products="products" :reports="reports"></gene-deliverables>
      </div>
      <!-- 服务与咨询 -->
      <div class="container">
          <new-consult type="gene" :typeList="['orderOnline','telePhone','download','email']"></new-consult>
      </div>
    </section>
  </div>
</template>
<script>
import bread from "@/components/bread"
import GeneTopBanner from "./gene-components/geneTopBanner"
import EnTitle from '@/components/EnTitle'
import GeneAdvantages from './gene-components/geneAdvantages'
import GeneDetailTable from './gene-components/geneDetailTable'
import GeneDeliverables from './gene-components/geneDeliverables'
export default {
  components:{
    bread, 
    GeneTopBanner,
    EnTitle,
    GeneAdvantages,
    GeneDetailTable,
    GeneDeliverables,
  },
  data () {
    return {
      smallTitle:'全基因组合成',
      bigTitle:'快速基因合成',
      advantagesList:[
        {
          img:'gene_second/rapid_page/icon_1',
          title:'高准确率',
          text:'Sanger测序验证保证\n序列100%准确',
        },
        {
          img:'gene_second/rapid_page/icon_2',
          title:'快速交付',
          text:'快至5个自然日',
        },
        
      ],
      tableColumn:[
        {
          label:'基因长度',
          prop:'geneLength',
        },
        {
          label:'生产周期（自然日）',
          prop:'productionCycle',
        },
        {
          label:'载体',
          prop:'carrier',
        },
      ],
      tableData:[
        {
          geneLength:'< 1.2 kb',
          productionCycle:'5',
          carrier:'库存载体或已验证正确客户自备载体',
        }
      ],
      products:'冻干质粒 DNA 一管 ( 高拷贝约4 μg/ 管，低拷贝1-4 μg/ 管 )\n含有重组质粒的穿刺菌一管',
      reports:'测序图谱 (.abl 文件 )\n目标序列 (.seq 文件 )\nCOA 文件'
    }
  },
  methods: {
    tableSpanMethod(){}
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/rapid_page.vue